import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  {
    checkboxCell: {
      paddingLeft: 0,
    },
    wideCell: {
      width: "100%",
    },
  },
  { name: "DiscountCountrySelectDialog" },
);
